import React, { ReactNode } from "react";

interface MaxWidthWrapperProps {
  children: ReactNode;
}

const MaxWidthWrapper: React.FC<MaxWidthWrapperProps> = ({ children }) => {
  return (
    <div
      style={{
        maxWidth: "1536px",
        margin: "auto",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
};
export default MaxWidthWrapper;
